var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-image",style:([_vm.imageStyles])},[_c('a',{attrs:{"target":"_blank","href":_vm.product.link}},[_c('img',{attrs:{"src":_vm.product.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }